exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".custom-input {\r\n    border: 1px solid #D4D4D4;\r\n    padding: .2rem .75rem;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/helpers/components/formWidgets/formWidgets.css
// module id = ../../../../../src/app/helpers/components/formWidgets/formWidgets.css
// module chunks = main